import { Box } from '@mantine/core';

export const EmptyState = () => {
  return (
    <Box
      style={{
        display: 'flex',
        height: 'calc(100vh - 70px - 32px)',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box>No payment data</Box>
    </Box>
  );
};
